import React from "react";
import BlogsComponent from "../components/Blogs";
import NavBar from "../components/NavBar";

const Activities = () => {
  return (
    <>
      <NavBar id="blogs" />
      <BlogsComponent />
    </>
  );
};

export default Activities;
